import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const purchases = [['Giulia F.', 'Torino', 'PILATES PRONTA™ — Pacchetto completo'], ['Martina R.', 'Milano', 'PILATES PRONTA™ — Pacchetto completo'], ['Elena B.', 'Roma', 'PILATES PRONTA™ — Pacchetto completo'], ['Laura C.', 'Bologna', 'PILATES PRONTA™ — Pacchetto completo']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    let cycleTimer: number | undefined;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-204" data-mp="1aw6183h7es2h">
      <div className="relative border border-emerald-950/10 bg-white p-4 pr-10 shadow-2xl" data-id="element-205" data-mp="i93fyd1jgdu6">
        <button type="button" aria-label="Chiudi la notifica di acquisto recente" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-slate-500 hover:text-[#241322]" data-id="element-206" data-mp="x6cblixvk3rp">
          <XIcon className="h-4 w-4" data-id="element-207" data-mp="28mkghr0s3r6j" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-emerald-800" data-id="element-208" data-mp="23kblkp4cif1s">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-emerald-500" data-id="element-209" data-mp="2anrwb840vej0">
            <CheckIcon className="h-3 w-3 text-white" data-id="element-210" data-mp="2fmmlqswhw1c3" />
          </span>
          Acquisto verificato
        </p>
        <p className="mt-3 text-sm font-semibold text-[#241322]" data-id="element-211" data-mp="2knaepk4aas8y">
          <strong data-id="element-212" data-mp="2pm3szereana6">{purchase[0]}</strong> da {purchase[1]}
        </p>
        <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-213" data-mp="2pjhjh9ky1xpb">
          ha appena acquistato{' '}
          <span className="font-bold text-emerald-800" data-id="element-214" data-mp="1wx6abaj9uogw">{purchase[2]}</span>
        </p>
      </div>
    </aside>;
}